import { InputType, loanOptionsConstants } from 'config'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    acquisitionDate: {
      inputType: 'text',
      type: 'date',
      title: 'Acquisition Date',
      value: '',
      error: '',
    },
    propertyType: {
      title: 'Property Type',
      inputType: 'select',
      hasDefaultOption: true,
      options: loanOptionsConstants.propertyType,
      error: '',
      disabled: true,
    },
    propertyStatus: {
      title: 'Property Status',
      inputType: 'select',
      hasDefaultOption: true,
      options: {
        finishedProperty: 'Finished property',
        unfinishedProperty: 'Unfinished property',
      },
      error: '',
    },
    currentValue: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Current Value',
      prefix: '$',
      value: '',
      error: '',
      span: 1,
    },
    currentValueDate: {
      inputType: 'text',
      type: 'date',
      title: 'Current Value Date',
      value: '',
      error: '',
      span: 1,
    },
    custom1: {
      inputType: 'custom',
      title: '',
      span: 'full',
    },

    CurrentSQFT: {
      inputType: 'text',
      type: 'number',
      title: 'Current SQFT',
      value: '',
      error: '',
      span: 1,
      required: true,
    },
    AfterRehadSQFT: {
      inputType: 'text',
      type: 'number',
      title: 'After Rehab SQFT',
      value: '',
      error: '',
      span: 1,
      required: true,
    },
    BedroomCount: {
      inputType: 'text',
      type: 'number',
      title: 'Bedroom Count',
      value: '',
      error: '',
      span: 1,
      required: true,
    },
    BathroomCount: {
      inputType: 'text',
      type: 'number',
      title: 'Bathroom Count',
      value: '',
      error: '',
      span: 1,
      required: true,
    },
    LotSize: {
      inputType: 'text',
      type: 'number',
      title: 'Lot Size',
      value: '',
      error: '',
      span: 1,
      required: true,
    },
    YearBuilt: {
      inputType: 'text',
      type: 'number',
      title: 'Year Built',
      value: '',
      error: '',
      span: 1,
      required: true,
    },
    lockboxCombo1: {
      inputType: 'text',
      title: 'Lockbox Combo #1',
      value: '',
      error: '',
      span: 1,
    },
    lockboxCombo2: {
      inputType: 'text',
      title: 'Lockbox Combo #2',
      value: '',
      error: '',
      span: 1,
    },

    PropertyConditionNotes: {
      inputType: 'textarea',
      title: 'Property condition notes',
      value: '',
      error: '',
      span: 'full',
    },
    LegalTitleIssues: {
      inputType: 'textarea',
      title: 'Legal/title issues',
      value: '',
      error: '',
      span: 'full',
    },
  }
}

export const PropertyProfileUnderwritingKeys = [
  'CurrentSQFT',
  'AfterRehadSQFT',
  'BedroomCount',
  'BathroomCount',
  'LotSize',
  'YearBuilt',
]
